module.exports = __webpack_public_path__ + "img/0.e53ff7ab.jpg";